import * as Preact from "preact"

import "./Passive.less"

export default class Passive {
    render() {
        const passive = this.props.passive
        if(passive === undefined) return
        if(passive.isHidden == true) return

        let power = 0
        if(passive.powerboost instanceof Function) {
            power = passive.powerboost({"unit": this.props.unit, "stage": this.props.stage}) || 0
        }
        if(passive.isHiddenUnlessActive == true && power == 0) return

        return (
            <div class="UnitPassive" isPressed={this.isPressed} anchored={this.props.anchored || "top"} style={{"background-color": passive.color}}
                onMouseDown={this.onMouseDown()} onMouseUp={this.onMouseUp()} onMouseOut={this.onMouseOut()} onMouseOver={this.onMouseOver()} onContextMenu={this.onContextMenu()}>
                <div class="Label">
                    <div class="Title"><span>{passive.title || "???"}</span></div>
                </div>
                <PassiveBreakdown passive={passive} unit={this.props.unit} stage={this.props.stage}/>
            </div>
        )
    }
    onMouseDown() {
        return (event) => {
            if(event.button != 2) return
            event.stopPropagation()
            this.isPressed = true
        }
    }
    onMouseUp() {
        return (event) => {
            if(event.button != 2) return
            event.stopPropagation()
            this.isPressed = false
        }
    }
    onMouseOut() {
        return (event) => {
            event.stopPropagation()
            this.isPressed = false
        }
    }
    onMouseOver() {
        return (event) => {
            if(event.button != 2 && event.buttons != 2) return
            event.stopPropagation()
            this.isPressed = true
        }
    }
    onContextMenu() {
        return (event) => {
            event.preventDefault()
            event.stopPropagation()
        }
    }
}

import {Powerboost} from "./Description.jsx"
import "./ItemBreakdown.less"

function PassiveBreakdown({passive, unit, stage}) {
    if(passive == undefined) return

    let power = 0
    if(passive.powerboost instanceof Function) {
        power = passive.powerboost({unit, stage}) || 0
    }

    return (
        <div class="PassiveBreakdown">
            <div class="Contents" isSmall={true}>
                <div class="Summary">
                    <div class="Title">{passive.title} <Powerboost>{power}</Powerboost></div>
                    <div class="CoolDescription">
                        {passive.description instanceof Function ? passive.description({passive, unit, stage}) : passive.description}
                    </div>
                </div>
                <div class="Flavor" hasFlavor={!!passive.flavor}>
                    <div class="Text">{passive.flavor}</div>
                </div>
            </div>
        </div>
    )
}

function PassiveNumeral({passive, unit, stage}) {
    if(passive == undefined) return

    let power = 0
    if(passive.powerboost instanceof Function) {
        power = passive.powerboost({unit, stage})
    }

    return (
        <div class="PassiveNumeral">
            {power > 0 ? "!" : ""}
        </div>
    )
}
